import { render, staticRenderFns } from "./onboardingVideo.html?vue&type=template&id=3b57414d&scoped=true&external"
import script from "./onboardingVideo.js?vue&type=script&lang=js&external"
export * from "./onboardingVideo.js?vue&type=script&lang=js&external"
import style0 from "./onboardingVideo.scss?vue&type=style&index=0&id=3b57414d&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b57414d",
  null
  
)

export default component.exports